import React from 'react';
import ScrollReveal from './ScrollReveal';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <ScrollReveal className="footer-section footer-logo" variant="fade-up" delay={80}>
          <img
            src="/assest/images/logo32.png"
            alt="Naya Villa"
            className="footer-logo-img"
          />
          <div className="social-media">
            <a
              href="https://www.instagram.com/naya_villa_/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Follow us on Instagram"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
              </svg>
            </a>
            <a
              href="https://x.com/naya_villa"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Follow us on X"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>
            <a
              href="https://www.tiktok.com/@naya_villa"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Follow us on TikTok"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.89 2.89 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
              </svg>
            </a>
          </div>
        </ScrollReveal>

        <ScrollReveal className="footer-section footer-links" variant="fade-up" delay={160}>
          <h3 className="footer-heading">Quick Links</h3>
          <ul className="footer-link-list">
            <li><a href="#residence" className="footer-link">Our Residence</a></li>
            <li><a href="#amenities" className="footer-link">Amenities</a></li>
            <li><a href="#about" className="footer-link">About Us</a></li>
            <li><a href="#location" className="footer-link">Location</a></li>
          </ul>
        </ScrollReveal>

        <ScrollReveal className="footer-section footer-contact" variant="fade-up" delay={240}>
          <h3 className="footer-heading">Contact</h3>
          <div className="contact-info">
            <p className="contact-item">
              <span className="contact-label">Phone: +255 625 313 162</span>
            </p>
            <p className="contact-item">
              <span className="contact-label">Location: Goba triple B bar, Oysterbay street (GOBA)<br />
              Dar es Salaam, Tanzania</span>
            </p>
          </div>
        </ScrollReveal>
      </div>
    </footer>
  );
}

export default Footer;
